import { MiscInvoiceDetailTable } from "../MiscInvoiceDetailTable";
import { MiscInvoiceTaxTable } from "../MiscInvoiceTaxTable";
import { Checkbox, DataHeader, DataSource, HorizontalSpacer, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMiscInvoice extends Layout {
    checkboxPrinted: Checkbox;
    checkboxReadyToProcess: Checkbox;
    dataheaderMiscInvoice: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacerTax: HorizontalSpacer;
    layoutImageTable: Layout;
    layoutMiscInvoiceDetailTable: MiscInvoiceDetailTable;
    layoutMiscInvoiceTaxTable: MiscInvoiceTaxTable;
    sourceExciseTaxMiscBill: DataSource;
    sourceMiscBill: DataSource;
    sourceMiscBillDetail: DataSource;
    tabExciseTaxes: Tab;
    tabGeneral: Tab;
    tabImages: Tab;
    tabInvoiceDetail: Tab;
    tabRecurringOptions: Tab;
    tabsetMiscInvoice: Tabset;
    textboxAllocationCode: Textbox;
    textboxArCycleCodeId: Textbox;
    textboxBillDate: Textbox;
    textboxBillType: Textbox;
    textboxBillingUserId: Textbox;
    textboxCustomerId: Textbox;
    textboxDetailGridTotalWithTaxes: Textbox;
    textboxEndDate: Textbox;
    textboxInvoiceNoString: Textbox;
    textboxLastBillDate: Textbox;
    textboxNextBillDate: Textbox;
    textboxNumberTimesBilled: Textbox;
    textboxOrderId: Textbox;
    textboxReferenceNumber: Textbox;
    textboxRemark: Textbox;
    textboxStartDate: Textbox;
    textboxTaxGridTotalCharges: Textbox;
    textboxTaxGridTotalWithTaxes: Textbox;
    textboxTotalBilledAmounts: Textbox;
    textboxTotalCharges: Textbox;
}
